// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"43ea5310","709":"0a19aed3"}[chunkId] + ".chunk.js";
};